<template>
  <div class="kt-grid kt-grid--ver kt-grid--root">
    <div id="error">
      <div class="error">
        <div class="error-code">
          <h3>{{ title }}</h3>
          <h1 v-html="getCode"></h1>
        </div>
        <h2>{{ message }}</h2>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#error {
  height: 100vh;
}

#error .error {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.error {
  max-width: 520px;
  width: 100%;
  line-height: 1.4;
  text-align: center;
}

.error .error-code {
  position: relative;
  height: 240px;
}

.error .error-code h1 {
  font-family: "Montserrat", sans-serif;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: 252px;
  font-weight: 900;
  margin: 0px;
  color: #595d6e;
  text-transform: uppercase;
  letter-spacing: -40px;
  margin-left: -20px;
}

.error .error-code h1 > span {
  text-shadow: -8px 0px 0px #fff;
}

.error .error-code h3 {
  font-family: sans-serif;
  position: relative;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  color: #595d6e;
  margin: 0px;
  letter-spacing: 3px;
  padding-left: 6px;
}

.error h2 {
  font-family: sans-serif;
  font-size: 20px;
  font-weight: 400;
  text-transform: uppercase;
  color: #595d6e;
  margin-top: 0px;
  margin-bottom: 25px;
}

@media only screen and (max-width: 767px) {
  .error .error-code {
    height: 200px;
  }
  .error .error-code h1 {
    font-size: 200px;
  }
}

@media only screen and (max-width: 480px) {
  .error .error-code {
    height: 162px;
  }
  .error .error-code h1 {
    font-size: 162px;
    height: 150px;
    line-height: 162px;
  }
  .error h2 {
    font-size: 16px;
  }
}
</style>

<script>
export default {
  name: "MainError",
  metaInfo() {
    return {
      title: this.getErrorTitle()
    };
  },
  data() {
    return {
      code: 404,
      title: "Not Found!",
      message: "we are sorry, but the page/record you requested was not found"
    };
  },
  mounted() {
    const errorInfo = {
      401: {
        title: "Unauthorized",
        message: "You are not autorized to perform requested action"
      },
      403: {
        title: "Forbidden",
        message: "You are not authorized to access the requested page."
      },
      404: {
        title: "Not found!",
        message:
          "we are sorry, but the page/content you requested was not found"
      },
      500: {
        title: "Internal Server Error",
        message: "Error have been reported. please check back later"
      },
      503: {
        title: "Service Unavailable",
        message: "Please check back later"
      }
    };

    this.code = this.$route.meta.code;
    this.title = errorInfo[this.code].title;
    this.message = errorInfo[this.code].message;
  },
  computed: {
    getCode() {
      let nCode = [];

      `${this.code}`.split("").map(cd => nCode.push(`<span>${cd}</span>`));

      return nCode.join("");
    }
  },
  methods: {
    getErrorTitle() {
      return "Not Found";
    }
  }
};
</script>
